import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import Back from "../Components/back";
import walletTransaction from "../Api/walletTransaction";
import Swal from "sweetalert2";
import ModelLaunchEdit from "../Components/ModelLaunchEdit";
import depositHistory from "../Api/depositHistory";

export default function WalletTransactionHistory() {
    const navigate = useNavigate();
    const [transactionHistory, setTransactionHistory] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [showSurveyEditModal, setShowSurveyEditModal] = useState(false)
    const [dataModal, setDataModal] = useState(null);


    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const formatAMPM = (date) => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return `${hours}:${minutes}${ampm}`;
    }

    const getPrevious = () => {
      setCurrentPage(currentPage - 1)
    }
    const getNext = () => {
      setCurrentPage(currentPage + 1)
    }

    const handlePageSizeChange = (event) => {
      setPageSize(Number(event.target.value));
      setCurrentPage(0); // Reset currentPage when pageSize changes
    };

    useEffect(() => {
        const fetchWalletTransaction = async () => {
            const request = {
                currentPage: currentPage,
                pageSize: pageSize,
            }
            try {
                const result = await depositHistory(request);
                setTransactionHistory(result.data);
            } catch (error) {
                console.error("API Error:", error.response.data.message);
                if (error.response.status === 401 || error.response.status === 500) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.title
                    })
                    localStorage.clear();
                    navigate("/");
                }
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                })
            }
        };
        fetchWalletTransaction();
    }, [setTransactionHistory, currentPage, pageSize]);

    const transactionsByStatus = {
        All: transactionHistory?.result?.content ?? [],
        In: transactionHistory?.result?.content?.filter((item) => item.adjustType.toUpperCase() === "IN") ?? [],
        Out: transactionHistory?.result?.content?.filter((item) => item.adjustType.toUpperCase()  === "OUT") ?? [],
    };

    const openLaunchEditModal = (trxId) => {
        setShowSurveyEditModal(true);
        setDataModal(trxId)
    };

    const closeLaunchEditModal = () => {
        setShowSurveyEditModal(false);
    };

    return (
        <>
            <div className="container mobile-page">

                <div className="container">
                    <div className="row">
                        <div className="col-2 d-flex align-items-center">
                            <Back location={"/home"}/>
                        </div>
                        <div className="col-9 text-center">
                            <span className="fs-3 text-white fw-bold">Wallet Transition History</span>
                        </div>
                    </div>
                </div>


                <nav >
                    <div className="nav nav-tabs mt-4 mb-4 d-flex flex-nowrap" id="nav-tab" role="tablist">
                        <button className="nav-link active" id="nav-All-tab" data-bs-toggle="tab" data-bs-target="#nav-All"
                                type="button" role="tab" aria-controls="nav-All" aria-selected="true"
                        >
                            <span className='lightGrey fw-bold fs-6'>All</span>
                        </button>
                        <button className="nav-link" id="nav-In-tab" data-bs-toggle="tab" data-bs-target="#nav-In"
                                type="button" role="tab" aria-controls="nav-In" aria-selected="false"

                        >
                            <span className='lightGrey fw-bold fs-6'>IN</span>
                        </button>
                        <button className="nav-link" id="nav-Out-tab" data-bs-toggle="tab" data-bs-target="#nav-Out"
                                type="button" role="tab" aria-controls="nav-Completed" aria-selected="false"

                        >
                            <span className='lightGrey fw-bold fs-6'>OUT</span>
                        </button>
                    </div>
                </nav>
                <div className="my-2 divider-grey"></div>
                <div className="tab-content" id="nav-tabContent">
                    <div className="tab-pane fade show active" id= {`nav-All`} role="tabpanel" aria-labelledby={`nav-All-tab`}
                         tabIndex="0">
                        {
                            transactionsByStatus['All']?.map((list,index) => {
                                const time = new Date(list?.trxDate);
                                const formattedTime = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')} | ${formatAMPM(time)}`;
                                return (
                                    <>
                                        <div key={index} className="container">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="mt-3 withdraw-time fs-6 text-white">{formattedTime}</div>
                                                </div>
                                                <div className="col-4 align-self-end">
                                                    <button className={`button-outline rounded-5 px-1 py-1 text-white ${list?.adjustType.toLowerCase()}`} style={{ fontSize: '12px' }}>
                                                        <span className='fw-bold'>{list?.adjustType.toUpperCase()}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="withdraw-tab mt-3 mb-3 p-4 rounded-4 light-black">
                                            <div className="row align-items-center">
                                                <div className="col-12">
                                                    <div className="fs-6 text-white fw-bold"> <span className='fs-6 fw-bold text-pink me-2'>Total Amount</span> USDT {list?.amount}</div>
                                                </div>
                                                <div className="my-3 divider-grey"></div>
                                                <div className="row">
                                                    <div className="col-6 d-flex flex-column">
                                                        <span className='fs-6 fw-bold text-pink'>Original Balance</span>
                                                        <span className='fs-6 fw-bold text-white'>USDT {list?.oriAmount}</span>
                                                    </div>
                                                    <div className="col-5 d-flex flex-column">
                                                        <span className='fs-6 fw-bold text-pink'>After Balance</span>
                                                        <span className='fs-6 fw-bold text-white'>USDT {list?.afterAmount}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                        <div className="d-flex justify-content-center mt-4">
                            <button className="rounded-3 mx-2" disabled={currentPage === 0} onClick={getPrevious}>
                                PREVIOUS
                            </button>

                            <select className="form-select" style={{ width: '100px' }} value={pageSize}
                                    onChange={handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                            </select>


                            <button className="rounded-3 mx-2" disabled={!transactionHistory?.result?.content?.last} onClick={getNext}>
                                NEXT
                            </button>
                        </div>
                    </div>

                    <div className="tab-pane fade" id= {`nav-In`} role="tabpanel" aria-labelledby={`nav-In-tab`}
                         tabIndex="0">
                        {
                            transactionsByStatus['In']?.map((list,index) => {
                                const time = new Date(list?.trxDate);
                                const formattedTime = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')} | ${formatAMPM(time)}`;
                                return (
                                    <>
                                        <div key={index} className="container">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="mt-3 withdraw-time fs-6 text-white">{formattedTime}</div>
                                                </div>
                                                <div className="col-4 align-self-end">
                                                    <button className={`button-outline rounded-5 px-1 py-1 text-white ${list?.adjustType.toLowerCase()}`} style={{ fontSize: '12px' }}>
                                                        <span className='fw-bold'>{list?.adjustType.toUpperCase()}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="withdraw-tab mt-3 mb-3 p-4 rounded-4 light-black">
                                            <div className="row align-items-center">
                                                <div className="col-12">
                                                    <div className="fs-6 text-white fw-bold"> <span className='fs-6 fw-bold text-pink me-2'>Total Amount</span> USDT {list?.amount}</div>
                                                </div>
                                                <div className="my-3 divider-grey"></div>
                                                <div className="row">
                                                    <div className="col-6 d-flex flex-column">
                                                        <span className='fs-6 fw-bold text-pink'>Original Balance</span>
                                                        <span className='fs-6 fw-bold text-white'>USDT {list?.oriAmount}</span>
                                                    </div>
                                                    <div className="col-5 d-flex flex-column">
                                                        <span className='fs-6 fw-bold text-pink'>After Balance</span>
                                                        <span className='fs-6 fw-bold text-white'>USDT {list?.afterAmount}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>

                    <div className="tab-pane fade" id= {`nav-Out`} role="tabpanel" aria-labelledby={`nav-Out-tab`}
                         tabIndex="0">
                        {
                            transactionsByStatus['Out']?.map((list,index) => {
                                const time = new Date(list?.trxDate);
                                const formattedTime = `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')} | ${formatAMPM(time)}`;
                                return (
                                    <>
                                        <div key={index} className="container">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="mt-3 withdraw-time fs-6 text-white">{formattedTime}</div>
                                                </div>
                                                <div className="col-4 align-self-end">
                                                    <button className={`button-outline rounded-5 px-1 py-1 text-white ${list?.adjustType.toLowerCase()}`} style={{ fontSize: '12px' }}>
                                                        <span className='fw-bold'>{list?.adjustType.toUpperCase()}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="withdraw-tab mt-3 mb-3 p-4 rounded-4 light-black">
                                            <div className="row align-items-center">
                                                <div className="col-12">
                                                    <div className="fs-6 text-white fw-bold"> <span className='fs-6 fw-bold text-pink me-2'>Total Amount</span> USDT {list?.amount}</div>
                                                </div>
                                                <div className="my-3 divider-grey"></div>
                                                <div className="row">
                                                    <div className="col-6 d-flex flex-column">
                                                        <span className='fs-6 fw-bold text-pink'>Original Balance</span>
                                                        <span className='fs-6 fw-bold text-white'>USDT {list?.oriAmount}</span>
                                                    </div>
                                                    <div className="col-5 d-flex flex-column">
                                                        <span className='fs-6 fw-bold text-pink'>After Balance</span>
                                                        <span className='fs-6 fw-bold text-white'>USDT {list?.afterAmount}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            {showSurveyEditModal && (
                <ModelLaunchEdit onClose={closeLaunchEditModal} trxId={dataModal} />
            )}
        </>
    );
}
